import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class BaseAppAuthGuardService implements CanActivate {

  constructor(private storage: Storage, private nav: NavController,private modalCtrl: ModalController,private helperService:HelperService) { }

  async getTokenExpirationDate(): Promise<Date> {
    // const decoded = JSON.parse(atob(token.split('.')[1]));
    let decoded
    let token = await this.getStorage();
    await this.helperService.decode(token).then((res)=>{
      decoded=res;
    })
    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  async checkInvalidToken() {
    try {
      const date = await this.getTokenExpirationDate();
      if (date === undefined) {
        return false;
      }
      return !(date.valueOf() > new Date().valueOf());
    } catch (error) {
      return true;
    }
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise((resolve) => {
      this.checkInvalidToken()
        .then(async invalid => {
          if (!invalid) {
            resolve(true);
          } else {
            const modal = await this.modalCtrl.getTop();
            if(modal) {
              await this.modalCtrl.dismiss();
            }
            this.nav.navigateRoot(['login'], { queryParams: { returnUrl: state.url } });
            resolve(false);
          }
        });        
    });
  }

  async getStorage(){
    let token=await this.storage.get('token');
    return token;
  }
}
